import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { makeFormField, chooseRandom } from '@/helpers';
import { Routes } from '@/router';

@Component({
  name: 'CmgLeaveGroupOrderModal',
})
export default class CmgLeaveGroupOrderModal extends Vue {

  name = makeFormField();
  saving = false;

  get args() {
    return this.$appStore.state.ui.modals.leaveGroupOrder.args;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.leaveGroupOrder.visible;
  }

  close() {
    this.$services.ui.setModalVisibility('leaveGroupOrder', false);

    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }

  async leaveGroupOrder() {
    let order = this.$appStore.state.order.pendingGroupOrder;
    const mealIds = this.$appStore.state.order.groupOrderMealIds;

    for (let mealId of mealIds) {
      if (order) {
        await this.$services.order.removeMealFromOrder(order, mealId);
        order = this.$appStore.state.order.pendingGroupOrder;
      }
    }
       
    this.updateDeliveryEstimate();
    this.$services.bag.setBagVisibility(false);
    this.$services.order.clearGroupParticipantMeal();
    this.$router.push({ name: Routes.Home }); 
    this.close();
  }

  private updateDeliveryEstimate() {
    const estimate = this.$appStore.state.checkout.delivery.estimate;
    const order = this.$services.order.getCurrentOrder();

    if (order != null && order.order.delivery != null && estimate != null) {
      this.$services.checkout.setDeliveryEstimate({
        ...estimate,
        deliveryFee: order.order.delivery.feeAmount,
      });
    }
  }
}
